import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { resetSearchData } from 'redux/modules/search/search';
import * as c from 'models/constants';
import { ITranslateProps, IAuthContext, ILanguage } from 'models/common';
import { LoginRegister } from 'containers';
import { UserMenu } from 'components/ContextMenus';
import { closeModal, showModal } from 'modules/modal';
import { IStore } from 'redux/IStore';
import { browserHistory, RouteComponentProps, withRouter } from 'react-router';
import { getCategoryDomainValues } from 'redux/modules/domainvalues';
import { changeLanguage } from 'redux/modules/user/userlanguage';
import { setShowShoppingBagDropdown } from 'modules/cart';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { getUserCard } from 'redux/modules/user/usercard';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { NotificationsDropdown } from 'containers/Notifications/Dropdown';
import { MenuRenderer } from 'containers/Common/MenuRenderer';
import { getPublishedMenuItems, resetData as resetMainMenuData } from 'redux/modules/menus/mainmenu';
import { MenuItemType } from 'models/enums/menuitemtype';
import { LanguageDropdown } from 'components';
import renderIcon from 'helpers/renderIcon';
import { Dispatch } from 'react-redux';
import { dropdown, IDropdownProps } from 'helpers/hooks';
import { IExtendedRouteProps } from 'routes/extendedroute';
import { isRestrictedModeQuery } from 'redux/modules/shop/helpers';
const classNames = require('classnames');

interface IProps
	extends IDropdownProps,
		RouteComponentProps<any, any>,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps>,
		ITranslateProps {
	context?: IAuthContext;
	magazineProps?: any;
	showHeaderCloseButton?: boolean;
}

interface IState {
	scrolled: boolean;
	mobileLanguagePicker: boolean;
}

const displayDesktop = 'd-none d-lg-inline-block';
const hideDesktop = 'd-block d-lg-none';

const mapStateToProps = (state: IStore) => ({
	cart: state.cart,
	userPreferences: state.userPreferences,
	notificationsDropdown: state.notificationsDropdown,
	userLanguage: state.userLanguage,
	languageDomainValues: state.domainValues.languages,
	categoriesDomainValues: state.domainValues.categories,
	baseUrlClient: state.fetchDefault.baseUrlClient,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	closeModal: () => dispatch(closeModal()),
	getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
	changeLanguage: (language: number, updateUserPreferences: boolean) =>
		dispatch(changeLanguage(language, updateUserPreferences)),
	setShowShoppingBagDropdown: (showShoppingBagDropdown: boolean) =>
		dispatch(setShowShoppingBagDropdown(showShoppingBagDropdown)),
	resetSearchData: () => dispatch(resetSearchData()),
	getUserCard: (id: string) => dispatch(getUserCard(id)),
	getShopCard: (id: string) => dispatch(getShopCard(id)),
	getPublishedMenuItems: (menuItemType: MenuItemType) => dispatch(getPublishedMenuItems(menuItemType)),
	resetMainMenuData: () => dispatch(resetMainMenuData(MenuItemType.Portal)),
});

@dropdown()
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalHeaderComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.handleUserImageClick = this.handleUserImageClick.bind(this);
		this.setShowShoppingBagDropdown = this.setShowShoppingBagDropdown.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.redirectHome = this.redirectHome.bind(this);
		this.handleShoppingBagClick = this.handleShoppingBagClick.bind(this);
		this.handleOnCategoryClick = this.handleOnCategoryClick.bind(this);
		this.handleOnLanguageChange = this.handleOnLanguageChange.bind(this);
		this.handleOnScrollEvent = this.handleOnScrollEvent.bind(this);
		this.renderUserMenu = this.renderUserMenu.bind(this);
		this.onLanguageChange = this.onLanguageChange.bind(this);
		this.openNewShop = this.openNewShop.bind(this);

		this.state = {
			scrolled: false,
			mobileLanguagePicker: false,
		};
	}

	public componentDidMount() {
		this.props.getCategoryDomainValues();
		this.props.getPublishedMenuItems(MenuItemType.Portal);
		window.addEventListener('scroll', this.handleOnScrollEvent);
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.userLanguage.hackFlagDispatched !== this.props.userLanguage.hackFlagDispatched ||
			prevProps.userLanguage.languageKey !== this.props.userLanguage.languageKey
		) {
			this.props.getPublishedMenuItems(MenuItemType.Portal);
		}
	}

	public componentWillUnmount() {
		window.removeEventListener('scroll', this.handleOnScrollEvent);
	}

	private handleOnScrollEvent() {
		const currentScrollPos = window.pageYOffset;
		if (currentScrollPos > 0 && !this.state.scrolled) {
			this.setState({
				scrolled: true,
			});
		} else if (currentScrollPos <= 0 && this.state.scrolled) {
			this.setState({
				scrolled: false,
			});
		}
	}

	private handleUserImageClick() {
		const url = '/profile/' + this.props.userPreferences.code;
		browserHistory.push(url);
	}

	private setShowShoppingBagDropdown(showShoppingBagDropdown: boolean) {
		this.props.setShowShoppingBagDropdown(showShoppingBagDropdown);
	}

	private handleShoppingBagClick(e: React.SyntheticEvent) {
		e.preventDefault();

		const { isAuthenticated, signinRedirect } = this.props.context;

		if (isAuthenticated()) {
			browserHistory.push('/cart');
		} else {
			signinRedirect('cart');
		}
	}

	private handleOnCategoryClick(e, category: number) {
		e.preventDefault();
		this.props.resetSearchData();
		browserHistory.push('/search?cat=' + category);
	}

	public closeModal() {
		this.props.closeModal();
	}

	public onLanguageChange(val: any) {
		const languageKey = parseInt(val, 10);
		this.redirectHome(null, languageKey);
		this.props.changeLanguage(languageKey, this.props.context.isAuthenticated());
		this.props.getPublishedMenuItems(MenuItemType.Portal);
	}

	public redirectHome(e, languageKey: number) {
		if (e) {
			e.preventDefault();
		} else if (
			!(this.props.location?.pathname?.startsWith('magazine') || this.props.location?.pathname?.startsWith('/magazine'))
		) {
			// don't redirect home except if it was clicked manually (has e) or is a magazine page
			return;
		}
		const culture = languageKey
			? this.props.languageDomainValues.find((x) => x.key === languageKey).culture
			: this.props.userLanguage.culture;

		if (culture) {
			browserHistory.push('/');
		}
	}

	private handleOnLanguageChange(val: any) {
		const languageKey = parseInt(val, 10);
		this.redirectHome(null, languageKey);
		this.props.changeLanguage(languageKey, this.props.context.isAuthenticated());
		this.props.getPublishedMenuItems(MenuItemType.Portal);
	}

	private openNewShop() {
		browserHistory.push('/forBusiness');
	}

	public renderUserMenu() {
		const { userPreferences, baseUrlClient, getShopCard, getUserCard } = this.props;

		const userMenuProps = {
			userPreferences,
			baseUrlClient,
			getShopCard,
			getUserCard,
			toggleMobileMenu: this.props.toggle,
		};
		return <UserMenu {...userMenuProps} />;
	}

	public renderLanguages(className?: string) {
		const { languageDomainValues, context } = this.props;
		const isLoggedIn = context.isAuthenticated();
		if (isLoggedIn) {
			return null;
		}

		const selectedLanguage = this.props.userLanguage.languageKey;
		return (
			<LanguageDropdown
				className={className}
				onLanguageChange={this.onLanguageChange}
				languageDomainValues={languageDomainValues}
				selectedLanguage={selectedLanguage}
			/>
		);
	}

	private renderMenuIcons() {
		//const { cart } = this.props;
		const isLoggedIn = this.props.context.isAuthenticated();
		const toggleMenu = (
			<button
				className="iconBtn mobileMenuToggle d-inline-block d-lg-none"
				type="button"
				onClick={(e) => this.props.toggle(e)}
			>
				{renderIcon(this.props.open ? 'hamby1' : 'hamby0')}
			</button>
		);
		if (isLoggedIn) {
			return (
				<>
					<NotificationsDropdown />
					{this.renderUserMenu()}
					{toggleMenu}
					<div className="additionalElements__separator"></div>
				</>
			);
		} else {
			return <>{toggleMenu}</>;
		}
	}

	private renderTopIcons() {
		const { t } = this.props;
		const isLoggedIn = this.props.context.isAuthenticated();
		const toggler = (
			<button
				className="iconBtn mobileMenuToggle d-inline-block d-lg-none"
				type="button"
				onClick={(e) => this.props.toggle(e)}
				ref={this.props.ref2}
			>
				{renderIcon(this.props.open ? 'hamby1' : 'hamby0')}
			</button>
		);
		if (isLoggedIn) {
			return (
				<>
					<div onClick={this.openNewShop} className="forBusiness">
						<span>{t('Navigation_Main_UserMenu_ForBusiness')}</span>
					</div>
					<NotificationsDropdown />
					{this.renderUserMenu()}
					{toggler}
				</>
			);
		} else {
			return (
				<>
					<div onClick={this.openNewShop} className="forBusiness">
						<span>{t('Navigation_Main_UserMenu_ForBusiness')}</span>
					</div>
					{this.renderLanguages(displayDesktop)}
					<LoginRegister />
					{toggler}
				</>
			);
		}
	}

	public render() {
		const { t, languageDomainValues, userLanguage } = this.props;
		const isLoggedIn = this.props.context.isAuthenticated();
		let textVersion: 'dark' | 'white' = this.state.scrolled ? 'dark' : 'white';
		const route: IExtendedRouteProps =
			this.props.route || (this.props.routes?.length ? this.props.routes[this.props.routes.length - 1] : null);
		if (route?.darkHeader) {
			textVersion = 'dark';
		}

		if (route?.noHeader) {
			return <></>;
		}

		const restrictedMode = route?.restrictedMode || isRestrictedModeQuery(this.props.location);

		const languageOptions: ILanguage[] = [];

		let selectedLanguageName = '';
		if (userLanguage?.languageKey && languageDomainValues) {
			selectedLanguageName = languageDomainValues.find((v) => v.key === userLanguage?.languageKey)?.value || '';
		}

		let i: number;
		if (languageDomainValues?.length > 0) {
			for (i = 0; i < 4; i++) {
				//remove when CH and RU languages are supported
				if (languageDomainValues[i] && languageDomainValues[i].key && languageDomainValues[i].culture) {
					languageOptions.push(languageDomainValues[i]);
				}
			}
		}

		return (
			<header
				id="header"
				className={
					'main-header text-' +
					textVersion +
					(isLoggedIn ? '' : ' guest') +
					(route?.landingPageHeader ? ' landingPageHeader' : '')
				}
			>
				<div
					className={classNames('header-row top', {
						'mobile-menu-open': this.props.open,
						'restricted-mode': restrictedMode,
					})}
					ref={this.props.ref1}
				>
					<div className="header-section">
						{!restrictedMode && (
							<a
								href="#"
								onClick={(e) => {
									this.redirectHome(e, null);
								}}
								className="logo"
							>
								<img
									className={classNames('dark', {
										'mobile-menu-logo-image': this.props.open,
									})}
									src={require('containers/Html/images/logo/glossiq.svg')}
									alt={t('App_Name')}
								/>
								<img
									className="white"
									src={require('containers/Html/images/logo/glossiq-white.svg')}
									alt={t('App_Name')}
								/>
							</a>
						)}
						{restrictedMode && (
							<span className="logo">
								<img
									className={classNames('dark', {
										'mobile-menu-logo': this.props.open,
									})}
									src={require('containers/Html/images/logo/glossiq.svg')}
									alt={t('App_Name')}
								/>
								<img
									className="white"
									src={require('containers/Html/images/logo/glossiq-white.svg')}
									alt={t('App_Name')}
								/>
							</span>
						)}
						<div className={`page-links ${this.props.open ? 'mobile' : ''}`}>
							{!this.state.mobileLanguagePicker ? (
								<MenuRenderer
									className="active"
									restrictedMode={restrictedMode}
									injectedItems={
										this.props.open && (
											<div className="injectedElements">
												<div className="injectedElements__separator"></div>
												{!isLoggedIn ? <LoginRegister /> : null}
												<div onClick={() => browserHistory.push('/shop')} className="forBusiness">
													<span>{t('Navigation_Main_UserMenu_ForBusiness')}</span>
												</div>
												<div
													className="mobileLanguageSelector"
													onClick={() =>
														this.setState((prev) => ({ mobileLanguagePicker: !prev.mobileLanguagePicker }))
													}
												>
													{t('User_UserPreferences_Label_Language')}
												</div>
											</div>
										)
									}
								>
									<div className={hideDesktop + ' additionalElements'}>{this.renderMenuIcons()}</div>
								</MenuRenderer>
							) : (
								<div className="mobileHeader__mobileLanguages">
									<div
										className="mobileHeader__mobileLanguages__title"
										onClick={() => {
											this.setState((prev) => ({ mobileLanguagePicker: !prev.mobileLanguagePicker }));
										}}
									>
										{renderIcon('landing_page_down', 16, 16, 'shop-present__navMenu__nav__mobileLanguages__back')}
										{t('User_UserPreferences_Dropdown_SelectLanguage')}
									</div>
									<div className="mobileHeader__mobileLanguages__wrapper">
										{languageOptions.map((opt) => {
											return (
												<figure
													key={opt.key}
													onClick={() => {
														this.props.changeLanguage(opt.key, isLoggedIn);
														this.props.getPublishedMenuItems(MenuItemType.Portal);
														this.setState((prev) => ({ mobileLanguagePicker: !prev.mobileLanguagePicker }));
													}}
													className={`mobileHeader__mobileLanguages__language ${
														selectedLanguageName === opt.value ? 'active' : ''
													}`}
												>
													<span>{opt.value}</span>
												</figure>
											);
										})}
									</div>
								</div>
							)}
						</div>
					</div>
					<div className="header-section">{this.renderTopIcons()}</div>
				</div>
			</header>
		);
	}
}

const PortalHeader = connect(mapStateToProps, mapDispatchToProps)(withRouter(withAuthContext(PortalHeaderComponent)));

export { PortalHeader };
